<template>
	<div id="app">
		<nav-bar class="nav"></nav-bar>
		<router-view></router-view>
	</div>
</template>

<script>
	import NavBar from "components/NavBar.vue"
	export default {
		name: 'app',
		components: {
			NavBar
		}
	}
</script>

<style lang="scss">
	body {
		margin: 0px;
	}

	.page {
		background: $background-1;
		width: 100%;
		min-height: 100vh;
		box-sizing: border-box;
		color: white;
	}
	
	.nav {
		position: fixed;
		top: 0px;
	}
	
	@font-face {
		font-family: 'iconfont';
		/* project id 1832283 */
		src: url('//at.alicdn.com/t/font_1832283_lvuzcp8o839.eot');
		src: url('//at.alicdn.com/t/font_1832283_lvuzcp8o839.eot?#iefix') format('embedded-opentype'),
			url('//at.alicdn.com/t/font_1832283_lvuzcp8o839.woff2') format('woff2'),
			url('//at.alicdn.com/t/font_1832283_lvuzcp8o839.woff') format('woff'),
			url('//at.alicdn.com/t/font_1832283_lvuzcp8o839.ttf') format('truetype'),
			url('//at.alicdn.com/t/font_1832283_lvuzcp8o839.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: "iconfont" !important;
		color: $color-1;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>
